import React from 'react';
import '../css/WorkingAtCDL.css';

const Banner = ({ backgroundImage }) => {
    return (
        <section 
            className="banner-header" 
            style={{ backgroundImage: `url(${backgroundImage})` }}
        ></section>
    );
};

export default Banner;
